// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"business-module--textWrapper--mtRAs","videoContainer":"business-module--videoContainer--3Z4Hc","ourBusiness":"business-module--ourBusiness--1RqJN"};